import { NgModule } from "@angular/core";
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { CustomIconsModule } from 'src/app/custom/icons/custom-icons.module';
import { CustomProductImageZoomTriggerComponent } from './custom-product-image-zoom-trigger.component';

@NgModule({
  declarations: [CustomProductImageZoomTriggerComponent],
  exports: [CustomProductImageZoomTriggerComponent],
  imports: [
    CustomIconsModule,
    IconModule,
    KeyboardFocusModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductImageZoomTriggerComponent: {
          component: CustomProductImageZoomTriggerComponent
        }
      }
    } as CmsConfig)
  ]
})
export class CustomProductImageZoomTriggerModule { }
